import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { threshold: { type: Number, default: 24 } }

  connect() {
    this.update = this.update.bind(this)
    this.ticking = false
    window.addEventListener("scroll", this.update, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.update)
    window.cancelAnimationFrame(this.frame)
    this.ticking = false
    document.documentElement.classList.remove("menu-2-header-compact")
  }

  update() {
    if (this.ticking) return

    this.ticking = true
    this.frame = window.requestAnimationFrame(() => {
      const compact = window.scrollY >= this.thresholdValue
      this.element.classList.toggle("is-compact", compact)
      document.documentElement.classList.toggle("menu-2-header-compact", compact)
      this.ticking = false
    })
  }
}
